import { createContext, useContext, useState, createElement, FC, ReactNode } from 'react';
import {SessionContext} from "./SessionContext";
import HybridModelSessionContext from "./HybridModelSessionContext";

export const EnersoundSessionContext = createContext<{
    session: SessionContext | HybridModelSessionContext | null;
    setSession: (s: SessionContext | HybridModelSessionContext) => void;
}>({
    session: null,
    setSession: () => {},
});

export const useEnersoundSessionContext = () => useContext(EnersoundSessionContext);


export const SessionProvider: FC<{children: ReactNode}> = ({ children }) => {
    const [session, setSession] = useState<SessionContext | HybridModelSessionContext | null>(null);
    return createElement(
        EnersoundSessionContext.Provider,
        { value: { session, setSession } },
        children
    );
};